document.addEventListener("DOMContentLoaded", async () => {
  const videoContainers = document.querySelectorAll(".video-element-container");

  videoContainers.forEach((container) => {
    const videoElement = container.querySelector(".page-video-banner-video");
    const imageElement = container.querySelector(".page-video-banner-preview");
    const controls = container.querySelectorAll(".video-controls svg");

    if (!videoElement) return;

    // Kontrol buton görünürlüklerini düzenleyen fonksiyon
    const changeControlVisibility = (action) => {
      const pause = container.querySelector(".video-controls svg[data-role='pause']");
      const play = container.querySelector(".video-controls svg[data-role='play']");
      const mute = container.querySelector(".video-controls svg[data-role='mute']");
      const unmute = container.querySelector(".video-controls svg[data-role='unmute']");

      if (action === "pause") {
        if (play) play.style.display = "block";
        if (pause) pause.style.display = "none";
      } else if (action === "play") {
        if (pause) pause.style.display = "block";
        if (play) play.style.display = "none";
      } else if (action === "mute") {
        if (mute) mute.style.display = "none";
        if (unmute) unmute.style.display = "block";
      } else if (action === "unmute") {
        if (mute) mute.style.display = "block";
        if (unmute) unmute.style.display = "none";
      }
    };

    // Videoyu yukleyip doğrudan başlatma fonksiyonu
    const startVideoAutomatically = () => {
      const src = videoElement.dataset.src;

      if (src) {
        videoElement.src = src;
        videoElement.load();

        // Video kareleri yuklendiginde resmi kaldır ve oynat
        videoElement.addEventListener(
          "loadeddata",
          () => {
            if (imageElement && imageElement.parentNode) {
              imageElement.remove();
            }
            
            // Otomatik oynatma dene
            videoElement
              .play()
              .then(() => {
                changeControlVisibility("play");
              })
              .catch((error) => {
                console.log("Autoplay tarayıcı tarafından engellendi:", error);
              });
          },
          { once: true }
        );
      }
    };

    // Kontrol butonlarına tıklama olayları
    controls.forEach((control) => {
      control.addEventListener("click", (e) => {
        e.stopPropagation();
        const targetSvg = e.currentTarget;
        const role = targetSvg.dataset.role;

        if (role === "play") {
          videoElement.play().then(() => {
            changeControlVisibility("play");
          });
        } else if (role === "pause") {
          videoElement.pause();
          changeControlVisibility("pause");
        } else if (role === "mute") {
          videoElement.muted = false;
          changeControlVisibility("mute");
        } else if (role === "unmute") {
          videoElement.muted = true;
          changeControlVisibility("unmute");
        }
      });
    });

    // Event dinleyicileri
    videoElement.addEventListener("play", () => changeControlVisibility("play"));
    videoElement.addEventListener("pause", () => changeControlVisibility("pause"));

    // Sayfa yuklendigi anda otomatik baslat
    startVideoAutomatically();
  });

  // SLIDER START
  const productSlider = new Swiper(".c-hp-product-slider", {
    slidesPerView: 1.3,
    spaceBetween: 10,
    breakpoints: {
      460: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      550: {
        slidesPerView: 2.2,
        spaceBetween: 10,
      },
      710: {
        slidesPerView: 3,
        spaceBetween: 5,
      },
      915: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      1200: {
        slidesPerView: 5,
        spaceBetween: 10,
      },
    },
    navigation: {
      nextEl: ".c-hp-product-slider .swiper-button-next",
      prevEl: ".c-hp-product-slider .swiper-button-prev",
    },
  });

  const pcUnitCards = document.querySelectorAll(
    ".c-hp-product-default .pcUnitCard"
  );

  async function getData(url) {
    try {
      let res = await fetch(url);
      if (!res.ok) {
        // console.log("fetch failed");
        throw new Error("something went wrong :( ");
      }
      let data = res.json();
      // console.log(data)
      return data;
    } catch (err) {
      throw new Error(err);
    }
  }

  pcUnitCards.forEach((pcUnitCard) => {
    pcUnitCard.addEventListener("click", async (e) => {
      let parentEl = e.target.closest(".product-cart");
      let customSpinnerParent = parentEl.querySelector(".customSpinnerParent");
      customSpinnerParent.style.display = "block";
      let variantsParent = parentEl.querySelector(
        ".product-card-variantsParent"
      );
      let href = parentEl.querySelector(".redirectToPP").getAttribute("href");

      let url = `https://pedalcommander.com/products/${e.target.dataset.pHandle}.js`;
      let data = await getData(url);
      if (data) {
        customSpinnerParent.style.display = "none";

        let variants = data.variants;
        variants.sort((a, b) => {
          if (variants.indexOf(a) < variants.indexOf(b)) return 1;
          else if (variants.indexOf(a) > variants.indexOf(b)) return -1;
          else return 0;
        });
        variantsParent.style.display =
          variantsParent.style.display === "flex" ? "none" : "flex";
        if (variants.length < 7) variantsParent.style.justifyContent = "center";
        variants.forEach((variant) => {
          const { id: variantID, title: variantTitle } = variant;
          let variantTitleArr = variantTitle.split(" / ");
          let variantPC = variantTitleArr[0];
          let variantYear = variantTitleArr[3];
          let variantEngine = variantTitleArr[4];
          //EXTRACTS "PC{digit}" from variant socket
          const variantPcCode = variantPC.match(/PC\d+/)?.[0];
          const isOutOfStock =
            window.outOfStockPcCodes?.includes(variantPcCode);
          let li = document.createElement("li");
          if (isOutOfStock) li.classList.add("out-of-stock");
          li.innerHTML = `<button onclick="redirectPPFunc('${variantID}','${href}','${variantPC}','${variantYear}')" >
                              <span>${variantYear}</span>
                              <span class="variantEngine">${variantEngine}</span>
                              ${
                                isOutOfStock
                                  ? '<span class="out-of-stock-indicator">OUT OF STOCK</span>'
                                  : ""
                              }
                        </button>`;
          variantsParent.appendChild(li);
        });
      }
    });
  });

  // SLIDER END

  const ddContainer = document.querySelector(".pc-pro-dropdown-container");
  const ddContent = document.querySelector(".pc-pro-dropdown-content");
  const collectionHandle = ddContent.dataset.collectionHandle;
  const bestSellersTitle = ddContent.dataset.bestSellersTitle;
  const makesTitle = ddContent.dataset.makesTitle;
  const noVehicleFoundText = ddContent.dataset.noVehicleFound;
  const ddList = document.querySelector(".pc-pro-dd-list");
  const ddSelections = document.querySelector(".pc-pro-selection-container");
  const ddButton = document.querySelector(".dropdown-button");
  const makeModels = await getMakeModels();
  const bestSellerMakes = ddContent.dataset.bestSellers?.split(",");
  const filteredMakes = Object.keys(makeModels).filter(
    (make) => !bestSellerMakes.includes(make)
  );

  getInitialDropdown({ addSearchBar: true });

  ddButton.addEventListener("click", handleDropdownButtonClick);

  // FUNCTIONS START

  function handleKeydown(e) {
    const highlightedElement = ddContent.querySelector(
      ".pc-pro-dd-list-item.highlight"
    );
    const focusableElements = ddContent.querySelectorAll(
      ".pc-pro-dd-list-item:not(.pc-pro-dd-search-bar-li):not(.pc-pro-dd-list-splitter):not(.no-hover)"
    );
    switch (e.key) {
      case "Escape":
        closeDropdown();
        highlightedElement?.classList.remove("highlight");
        break;
      case "ArrowDown": {
        e.preventDefault();
        ddContent.dataset.keyboardControls = "true";
        const nextElement = highlightedElement?.nextElementSibling;
        if (!nextElement) {
          const elementToFocus = focusableElements[0];
          elementToFocus.classList.add("highlight");
          centerElementInContainer(elementToFocus, ddList);
        } else {
          highlightedElement.classList.remove("highlight");
          nextElement.classList.add("highlight");
          centerElementInContainer(nextElement, ddList);
        }
        break;
      }
      case "ArrowUp": {
        e.preventDefault();
        ddContent.dataset.keyboardControls = "true";
        const previousElement = highlightedElement?.previousElementSibling;
        if (!previousElement) {
          const elementToFocus =
            focusableElements[focusableElements.length - 1];
          elementToFocus.classList.add("highlight");
          centerElementInContainer(elementToFocus, ddList);
        } else {
          highlightedElement.classList.remove("highlight");
          previousElement.classList.add("highlight");
          centerElementInContainer(previousElement, ddList);
        }
        break;
      }
      case "Enter":
        e.preventDefault();
        highlightedElement.click();
        break;
    }
  }

  function centerElementInContainer(element, container) {
    const elementRect = element.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    const offset =
      elementRect.top -
      containerRect.top -
      containerRect.height / 2 +
      elementRect.height / 2;
    container.scrollTop += offset;
  }
  function getInitialDropdown({ addSearchBar }) {
    if (addSearchBar) {
      appendSearchBar();
    }
    ddList.style.height = "";
    const bestSellersSplitter = getSplitter({ text: bestSellersTitle });
    ddList.append(bestSellersSplitter);
    fillListMakes(bestSellerMakes);

    const makesSplitter = getSplitter({ text: makesTitle });
    ddList.append(makesSplitter);
    fillListMakes(filteredMakes);
  }

  function handleDropdownButtonClick() {
    const isOpened = ddContent.dataset.dropdownOpened === "true";
    if (isOpened) {
      closeDropdown();
    } else {
      openDropdown();
    }
  }

  function openDropdown() {
    ddContent.dataset.dropdownOpened = true;
    ddContent.querySelector(".pc-pro-search-bar")?.focus();
    window.addEventListener("keydown", handleKeydown);
    window.addEventListener("click", handleDocumentClick);
  }

  function closeDropdown() {
    ddContent.dataset.dropdownOpened = false;
    ddContent.dataset.keyboardControls = "false";
    window.removeEventListener("keydown", handleKeydown);
    window.removeEventListener("click", handleDocumentClick);
  }

  function handleDocumentClick(e) {
    const closestDropdownContent = e.target.closest(".pc-pro-dropdown-content");
    if (
      !closestDropdownContent &&
      !e.target.classList.contains("pc-pro-dd-list-item")
    ) {
      closeDropdown();
    }
  }

  function fillListMakes(items) {
    items.forEach((item) => {
      const liElement = getMakeListItem({ make: item });
      ddList.append(liElement);
    });
  }

  function fillListModels(make) {
    const models = makeModels[make];
    clearDD();
    models.forEach((model) => {
      const liElement = getModelListItem({ model, link: `${make} ${model}` });
      ddList.append(liElement);
    });
    // console.log(models);
  }

  function clearDD() {
    const totalChildren = ddList.children.length;
    for (let i = totalChildren - 1; i > 0; i--) {
      ddList.removeChild(ddList.children[i]);
    }
  }

  function appendSearchBar() {
    const li = document.createElement("li");
    li.classList.add("pc-pro-dd-list-item", "pc-pro-dd-search-bar-li");
    const input = document.createElement("input");
    input.type = "text";
    input.classList.add("pc-pro-search-bar");
    input.addEventListener("input", handleSearchBarChange);
    input.placeholder = "Search";
    li.append(input);
    ddList.append(li);
  }

  function handleSearchBarChange(e) {
    const searchValue = e.target.value.toLowerCase();
    ddList.style.height = "";

    clearDD();
    if (searchValue === "") {
      getInitialDropdown({ addSearchBar: false });
      return;
    }
    const foundArray = [];
    Object.keys(makeModels).forEach((make) => {
      const models = makeModels[make];

      if (make.toLowerCase().includes(searchValue)) {
        foundArray.push({ type: "make", name: make });
      }

      models.forEach((model) => {
        if (model.toLowerCase().includes(searchValue)) {
          foundArray.push({ type: "model", name: `${make} ${model}` });
        }
      });
    });

    if (foundArray.length < 5) {
      const newHeight = 68 + foundArray.length * 52 + "px";
      ddList.style.height = newHeight;
    }

    if (foundArray.length < 1) {
      const listItem = getListItem({ text: noVehicleFoundText });
      ddList.append(listItem);
      ddList.style.height = "120px";
      return;
    }

    foundArray.sort((a, b) => {
      if (a.type === "make" && b.type === "model") return -1;
      if (a.type === "model" && b.type === "make") return 1;
      return 0;
    });
    foundArray.forEach((item) => {
      if (item.type === "make") {
        const makeLi = getMakeListItem({ make: item.name });
        ddList.append(makeLi);
      } else {
        const modelLi = getModelListItem({ model: item.name, link: item.name });
        ddList.append(modelLi);
      }
    });
  }

  function getSplitter({ text }) {
    const li = document.createElement("li");
    li.classList.add("pc-pro-dd-list-item", "pc-pro-dd-list-splitter");
    li.innerText = text;
    return li;
  }

  function getMakeListItem({ make }) {
    const li = document.createElement("li");
    li.classList.add("pc-pro-dd-list-item");
    li.innerText = make;
    li.addEventListener("click", () => {
      removeSelectionItems();
      if (makeModels[make].length < 5) {
        const newHeight = 68 + makeModels[make].length * 52 + "px";
        ddList.style.height = newHeight;
      } else {
        ddList.style.height = "";
      }
      createSelectionItem({ text: make });
      fillListModels(make);
      document.querySelector(".pc-pro-search-bar").value = "";
    });
    addHighlightEventListeners(li);
    return li;
  }
  function getModelListItem({ model, link }) {
    const li = document.createElement("li");
    li.classList.add("pc-pro-dd-list-item");
    li.innerText = model;
    li.addEventListener("click", () => {
      redirectToProductPage(link);
    });
    addHighlightEventListeners(li);
    return li;
  }

  function addHighlightEventListeners(el) {
    el.addEventListener("mouseenter", () => {
      const isKeyboardMode = ddContent.dataset.keyboardControls === "true";
      if (!isKeyboardMode) {
        el.classList.add("highlight");
      }
    });
    el.addEventListener("mouseleave", () => {
      const isKeyboardMode = ddContent.dataset.keyboardControls === "true";
      if (!isKeyboardMode) {
        el.classList.remove("highlight");
      }
    });
  }

  function getListItem({ text }) {
    const li = document.createElement("li");
    li.classList.add("pc-pro-dd-list-item", "no-hover");
    li.innerText = text;
    return li;
  }

  function redirectToProductPage(makeModel) {
    const changedMakeModel = makeModel.toLowerCase().replaceAll(" ", "-");
    window.location = `${window.Shopify.routes.root}products/${changedMakeModel}`;
  }

  function removeSelectionItems() {
    ddSelections.innerHTML = "";
  }
  function createSelectionItem({ text }) {
    const div = document.createElement("div");
    const cross = document.createElement("button");
    cross.classList.add("pc-pro-selection-delete");
    cross.addEventListener("click", () => {
      clearDD();
      getInitialDropdown({ addSearchBar: false });
      div.classList.remove("visible");
      setTimeout(() => {
        div.remove();
      }, 200);
    });
    const textEl = document.createElement("p");
    div.classList.add("pc-pro-selection-item");
    textEl.innerText = text;
    div.append(textEl, cross);
    ddSelections.append(div);
    setTimeout(() => {
      div.classList.add("visible");
    }, 20);
  }

  async function fetchAllProducts() {
    let hasNextPage = true;
    let endCursor = null;
    let allVariants = [];
    const endpoint = `/api/2024-07/graphql`;
    const headers = {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": "960b68e3d27e55870e9ad333d5a199a1",
    };
    const fetchProducts = async (cursor = null) => {
      const query = `
      {
        collectionByHandle(handle: "${collectionHandle}") {
          products(first: 250${cursor ? `, after: "${cursor}"` : ""},) {
            pageInfo {
              hasNextPage
              endCursor
            }
            nodes {
              vendor
              variants(first: 1) {
                nodes {
                  title
                }
              }
              
            }
          }
        }
      }
      `;
      try {
        const response = await fetch(endpoint, {
          method: "POST",
          headers: headers,
          body: JSON.stringify({ query }),
        });

        const data = await response.json();
        // console.log(data);
        return data.data.collectionByHandle.products;
      } catch (error) {
        console.log(error);
        console.error("Error fetching GraphQL data:", error);
      }
    };

    while (hasNextPage) {
      const productsData = await fetchProducts(endCursor);
      allVariants = allVariants.concat(
        productsData.nodes.map((node) => node.variants.nodes[0].title)
      );
      hasNextPage = productsData.pageInfo.hasNextPage;
      endCursor = productsData.pageInfo.endCursor;
    }
    return allVariants;
  }

  async function getMakeModels() {
    const allVariants = await fetchAllProducts();

    const makes = {};
    allVariants.forEach((variant) => {
      const [pcCode, make, model, year, engine] = variant
        .split("/")
        .map((item) => item.trim());
      if (!pcCode.startsWith("PC")) return;
      if (!makes[make]) {
        makes[make] = [model];
      } else {
        makes[make].push(model);
      }
    });
    const orderedMakes = {};
    Object.keys(makes).map((key) => {
      const orderedModels = makes[key].sort();
      orderedMakes[key] = orderedModels;
    });
    return orderedMakes;
  }
  // FUNCTIONS END
});

function redirectPPFunc(id, href, pc, year, make, model) {
  window.localStorage.setItem(
    "hpValues",
    JSON.stringify({ id, selection: `${pc} / ${year}` })
  );
  window.location.href = href;
}
